// extracted by mini-css-extract-plugin
export default {"root":"SimpleBadge_root__g-0ui"};